import React from 'react';
import ButtonAct from './ButtonAct';

export const cellRenderPopupActM1 = (data) => {
  const selectedRows = data
    && data.component
    && data.component.getSelectedRowsData
    && data.component.getSelectedRowsData();

  if (data.value && data.value !== '') {
    // дополнительный класс на ячейку с кнопкой
    // try {
    //   if (data.cellElement) {
    //     data.cellElement.classList.add('td-button-cell-render');
    //   }
    // } catch (error) {
    //   console.log(error);
    // }

    // console.log('ActM1data = ', data);
    return (
      <ButtonAct data={data}
                 types="mh1"
                 selectedRows={selectedRows || []}
      />
    );
  }
  return (
    <span />
  );
};

export const cellRenderPopupActM3 = (data) => {
  const selectedRows = data
    && data.component
    && data.component.getSelectedRowsData
    && data.component.getSelectedRowsData();

  if (data.value && data.value !== '') {
    // дополнительный класс на ячейку с кнопкой
    // try {
    //   if (data.cellElement) {
    //     data.cellElement.classList.add('td-button-cell-render');
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    return (
      <ButtonAct data={data}
                 types="mh3"
                 selectedRows={selectedRows || []}
      />
    );
  }
  return (
    <span />
  );
};

export const cellRenderPopupActM15 = (data) => {
  if (data.value && data.value !== '') {
    return (
      <ButtonAct data={data}
                 types="m15"
      />
    );
  }
  return (
    <span />
  );
};

export const cellRenderPopupActM15B = (data) => {
  if (data.value && data.value !== '') {
    return (
      <ButtonAct data={data}
                 types="m15B"
      />
    );
  }
  return (
    <span />
  );
};

export const cellRenderPopupAct = (data) => {
  const selectedRows = data
    && data.component
    && data.component.getSelectedRowsData
    && data.component.getSelectedRowsData();

  if (data.value && data.value !== '') {
    let docType = '';
    // eslint-disable-next-line default-case
    switch (data.data.docTypeNumId) {
      case 1:
        docType = 'mh1';
        break;
      case 2:
        docType = 'm4';
        break;
      case 3:
        docType = 'mh3';
        break;
      case 4:
        docType = 'tn';
        break;
      case 15:
        docType = 'm15';
        break;
      case 16:
        docType = 'm15B';
        break;
    }
    return (
      <ButtonAct data={data}
                 types={docType}
                 selectedRows={selectedRows || []}
                 statusId={data.data.docStatus}
                 adminDocNumId={data.data.docNumId}
                 adminDocStatus={data.data.docStatus}
      />
    );
  }
  return (
    <span />
  );
};

export const cellRenderPopupTn = (data) => {
  if (data.value && data.value !== '') {
    return (
      <ButtonAct data={data}
                 types={'tn'}
                 statusId={data.data.docStatus}
                 adminDocNumId={data.data.ttnNumId}
                 adminDocStatus={data.data.ttnDocStatus}
      />
    );
  }
  return (
    <span />
  );
};
